import { Component, OnInit } from '@angular/core';
import { StorageService } from 'src/app/service/storage.service';
import { TutorService } from 'src/app/service/tutor.service';
import { apiService } from 'src/app/service/api.service';
import { ModalCambiarPassComponent } from '../jardin/components/dialogs/modal-cambiar-pass/modal-cambiar-pass.component'
import { ModalCambiarFotoperfilComponent } from '../jardin/components/dialogs/modal-cambiar-fotoperfil/modal-cambiar-fotoperfil.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-mega-tutor',
  templateUrl: './mega-tutor.component.html',
  styleUrls: ['./mega-tutor.component.css']
})
export class MegaTutorComponent implements OnInit {

  menuMostrar : string;
  cargando = true;
  megaTutorData: any;
  tutores: any;
  idUsuario : any;
  urlProfile: any;
  primerNombreMegatutor : string;

  constructor(
    private storageService: StorageService,
    private api: apiService,
    private tutorService: TutorService,
    public dialog: MatDialog,
  ) { }

  ngOnInit(): void {
    this.idUsuario = this.storageService.getCurrentUser().idUsuario;
    this.menuMostrar = this.storageService.getMenuActivo() != null ? this.storageService.getMenuActivo() : 'inicio' ;
    this.getMegaTutor(this.idUsuario);
    this.getFotoPerfil();
    this.cargando = false;
  }

  menuVisible(item) {
    this.storageService.setMenuActivo(item);
    this.menuMostrar = this.storageService.getMenuActivo();
  }

  cerrarSesion(){
    this.storageService.logout();
  }


  getFotoPerfil() {
    this.api.API_POST_obtenerFotoPerfil(this.idUsuario).subscribe((response:any) => {
      if(response.payload != null){
        this.urlProfile = "data:image/jpg;base64,"+response.payload;
      }else{
        this.urlProfile = "../../../assets/JUNJI_avatar.svg";
      }
      
    },
    (err) => { 
      this.urlProfile = "../../../assets/JUNJI_avatar.svg";
      console.log(err)
    })
  }

  cambiarPass(){ 
    const dialogRef = this.dialog.open(ModalCambiarPassComponent, { disableClose: true }); 
    dialogRef.afterClosed().subscribe(result => {
      console.log('Mensaje desde la modal: '+result);      
      if(result=='refresh'){
      

      }
    });
  }

  capitalize(string){
    return string[0].toUpperCase() + string.slice(1);
  }

  cambiarFoto(){
    const dialogRef = this.dialog.open(ModalCambiarFotoperfilComponent, { disableClose: true }); 
    dialogRef.afterClosed().subscribe(result => {
      this.ngOnInit();
    });
  }

  getMegaTutor(id) {
      this.tutorService.API_POST_getTutorObjectByIdUsuario(id).subscribe((response:any) => {
        this.megaTutorData = response.payload;
        const nombre = this.megaTutorData.nombres.split(' ');
        this.primerNombreMegatutor = this.capitalize(nombre[0]);
      },
      (err) => { 
        console.log(err)
      })
  }

  

}
